import axios from "axios";
import { ENV_REACT_APP } from "../Configurations/ENV_Config";
import { getToken } from "../Utils/tokenStorage";

// Cross-property homeowner timeline (July Task 4.9). Same axios-direct + Bearer
// pattern as permitApi/contractApi. Backed by GET /api/me/timeline.
const apiBase = (path: string) =>
  `${ENV_REACT_APP?.REACT_APP_API_BASE_URL || ""}${path}`;

const authHeaders = (): Record<string, string> => {
  const t = getToken();
  return t ? { Authorization: `Bearer ${t}` } : {};
};

export type TimelineKind = "record" | "permit";

export interface TimelineProperty {
  propertyId: string; // REAPI id — used for the property deep link
  mongoId: string;
  address: string;
}

export interface TimelineEvent {
  id: string;
  kind: TimelineKind;
  date: string; // ISO
  dateLabel: string; // "Completed" | "Recorded" | "Issued" | "Added"
  title: string;
  subtitle: string | null;
  status: string | null;
  statusLabel: string | null;
  recordId?: string | null;
  tradeType?: string | null;
  permitNumber?: string;
  sourceUrl?: string | null;
  amount: number | null;
  property: TimelineProperty | null;
}

export interface TimelineResponse {
  properties: TimelineProperty[];
  events: TimelineEvent[];
  counts: { records: number; permits: number; total: number };
}

export const getMyTimeline = async (): Promise<TimelineResponse> => {
  const res = await axios.get(apiBase("/api/me/timeline"), {
    headers: authHeaders(),
  });
  const d = res.data?.data || {};
  return {
    properties: d.properties || [],
    events: d.events || [],
    counts: d.counts || { records: 0, permits: 0, total: 0 },
  };
};

export const timelineErrMsg = (
  e: any,
  fallback = "Something went wrong."
): string =>
  e?.response?.data?.errors?.message ||
  e?.response?.data?.message ||
  e?.message ||
  fallback;
